import React from "react";
import Skeleton from "react-loading-skeleton";
import { Scrollbar } from "react-scrollbars-custom";

export default function SkeletonStudentHub() {
    return (
        <React.Fragment>
            {/* <div class="card-simple-header d-flex border-bottom">
                <h4 class="my-md-2 my-0 landing-heading no-margin heading_color_dynamic">Student <span>Hub</span></h4>
                <div className="lecture-detail-bottom">
                </div>
            </div> */}
            <div class="card-simple">
                <div class="card-simple-body">
                    {/* <Scrollbar> */}
                        <div className="tab-content">
                            <div className="tab-pane active" id="all">
                                <ul className="Tickets-list-ul list-unstyled m-0">
                                    {Array(10)
                                        .fill()
                                        .map((item, index) => (
                                            <li key={index}>
                                                <Skeleton height={100} />
                                                {/* <Skeleton width={350} height={150} /> */}
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            <div className="tab-pane fade" id="Pending-Student"></div>
                            <div className="tab-pane fade" id="Pending-Academy"></div>
                        </div>
                    {/* </Scrollbar> */}
                </div>
            </div>
        </React.Fragment>
    )
}